import React from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
  Typography,
  Dialog,
} from '@material-ui/core';
import LottieAnimation from '../LottieAnimation';
import { SubTitle1Text } from '../../TextVariants';
import yappyPulse from '../../../resources/lottiefiles/yappy-pulse.json';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
    },
    container: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    dialogPaper: {
      background: 'linear-gradient(180deg, #CEE8FF 10.19%, #F9F9F9 100%)',
    },
    bodyText: {
      fontSize: theme.spacing(2),
      width: theme.spacing(30),
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.spacing(1.625),
      },
    },
  }),
);

type Props = {
  open: boolean;
  message: string;
};

const YappyProcessingDialog = ({ open, message }: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Dialog
      className={classes.root}
      fullScreen
      open={open}
      PaperProps={{ classes: { root: classes.dialogPaper } }}
    >
      <div className={classes.container}>
        <SubTitle1Text align="center" style={{ fontWeight: 900 }}>
          Espere unos segundos...
        </SubTitle1Text>
        <LottieAnimation
          data-testid="loading-animation"
          animationJson={yappyPulse}
          width="150px"
          height="150px"
        />
        <Typography align="center" className={classes.bodyText}>
          {message}
        </Typography>
      </div>
    </Dialog>
  );
};

export default YappyProcessingDialog;
